import { render } from "./VerifyCode.vue?vue&type=template&id=057af272&scoped=true"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"

import "./VerifyCode.vue?vue&type=style&index=0&id=057af272&lang=scss"
import "./VerifyCode.vue?vue&type=style&index=1&id=057af272&lang=scss&scoped=true"

import exportComponent from "/var/www/app/app-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057af272"]])

export default __exports__